const formatDateToMMDDYYYY = (date: Date): string => {
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const year = date.getFullYear();
  
  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  const hoursStr = String(hours).padStart(2, '0');
  
  return `${month}/${day}/${year}, ${hoursStr}:${minutes}:${seconds} ${ampm}`;
};

export const ConvertUTCtoCDT = (inputDate:string) => {
    if (!inputDate) return '';
    
    var utc = new Date(inputDate);
    
    // Check if date is valid
    if (isNaN(utc.getTime())) return '';
    
    // Get dates for January and July
    let dateJan = new Date(utc.getFullYear(), 0, 1);
    let dateJul = new Date(utc.getFullYear(), 6, 1);
  
    // Get timezone offset
    let timezoneOffset = Math.max(dateJan.getTimezoneOffset(), dateJul.getTimezoneOffset());
    var timelagging = 5; // 5 or 6 =: DEFAULT TO 5.
    if (utc.getTimezoneOffset() > timezoneOffset) {
      // Adjust date by 5 hours
      timelagging = 6
    }
  
    const convertedDate = new Date(utc.getTime()-((1 * 60 * 60 * 1000) * timelagging));
    return formatDateToMMDDYYYY(convertedDate);
}

export const isNullEmpty =(value:string)=>{
  return (value == null || value == undefined || (typeof value === "string" && value.trim().length === 0));
}